module.exports = __webpack_public_path__ + "static/media/fort-awesome.214be5d8.svg";